import React from 'react';
import './SelectButtonQuizType2.scss';

const SelectButtonQuizType2 = ({ picture, button1, button2, onAnswer }) => {
	const backgroundStyle = {
		backgroundImage: `url(${picture})`,
	};

	return (
		<>
			<div
				className="quiz-body-content"
				id="quiz-content"
				style={backgroundStyle}
			></div>
			<div className="quiz-body-button-wrapper">
				<div
					className="quiz-body-button2"
					id="button1"
					onClick={() => onAnswer('1')}
				>
					<div className="quiz-body-button-text">{button1}</div>
				</div>
				<div
					className="quiz-body-button2"
					id="button2"
					onClick={() => onAnswer('2')}
				>
					<div className="quiz-body-button-text">{button2}</div>
				</div>
			</div>
		</>
	);
};

export default SelectButtonQuizType2;
